import { Footer } from '../../../components/footer';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import moment from 'moment';
import PropTypes from 'prop-types';


const SwapInCome = ({ userHistory, page, setPage, rowsPerPage, setRowsPerPage }) => {



    const totalPages = Math.ceil(userHistory?.data?.count / rowsPerPage);

    const handlePageChange = (newPage) => {
        const currentScrollY = window.scrollY;

        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
            window.requestAnimationFrame(() => {
                window.scrollTo(0, currentScrollY);
            });
        }
    };

    return (
        <>
            <div>
                <div>
                    <div className='container'>
                        <div className="row">
                            <div className="col-12">
                                <div className="appcard mb-4 px-0 pb-2 cardbg">
                                    <div className="cardHeader border-bottom-0 d-flex justify-content-between flex-wrap px-4 pb-0">
                                        <div className='bxTitle'>
                                            <span>Swap Income</span>
                                        </div>
                                    </div>
                                    <div className="px-4 mb-3">
                                        <div className='row justify-content-between'>
                                            <div className="col-md-6 mb-2 mb-md-0 text-center text-md-left">
                                                <div className='d-inline-flex g-8 align-items-center'>
                                                    <span className='fs-18 fw-400 text-white-60'>Show</span>
                                                    <div className='form-group mb-0 formInputs gradientBg'>
                                                        <select className='form-control' onChange={(e) => {
                                                            setRowsPerPage(Number(e.target.value));
                                                            setPage(0);
                                                        }}>
                                                            <option value="10">10</option>
                                                            <option value="30">30</option>
                                                            <option value="50">50</option>
                                                        </select>
                                                    </div>
                                                    <span className='fs-18 fw-400 text-white-60'>entries</span>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className='table-responsive mb-3'>
                                        <table className='table myapptable table-hover table-borderless mb-0'>
                                            <thead>
                                                <tr>
                                                    <th className='pl-4'>S.No</th>
                                                    <th>Type</th>

                                                    <th>To Topup Wallet</th>

                                                    <th>Date & Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    userHistory?.data && userHistory.data.length > 0 ? (
                                                        userHistory.data.map((v, i) => (
                                                            <tr key={v?._id}>
                                                                <td className='pl-4'>{page * rowsPerPage + (i + 1)}</td>
                                                                <td >Swap</td>


                                                                <td>{v?.amount != null
                                                                    ? Number(v?.amount)
                                                                        .toFixed(5)
                                                                        .replace(/(\.\d*?[1-9])0+$/, "$1")   // remove trailing zeros after decimal
                                                                        .replace(/\.0+$/, "")             // remove decimal if only zeros remain

                                                                    : "--"
                                                                } <span className="text-white-60">USDT</span></td>
                                                                <td className='pr-4 text-nowrap'>
                                                                    <span>{moment(v.createdAt).format("DD/MM/YYYY | hh:mm A")}</span>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="7" className="text-center">No data found</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="px-4">
                                        <div className='row'>

                                            <div className='col-lg-12'>
                                                <Pagination aria-label="Page navigation" className='customPagination'>
                                                    <PaginationItem disabled={page === 0}>
                                                        <PaginationLink previous href="#" onClick={() => handlePageChange(page - 1)} className='prevbtn'>
                                                            <i className='bi bi-arrow-left align-bottom'></i> Previous
                                                        </PaginationLink>
                                                    </PaginationItem>
                                                    <span className='number'>

                                                        {page < 3 ? (
                                                            Array.from({ length: Math.min(3, totalPages) }, (_, index) => (
                                                                <PaginationItem key={index} active={index === page} className={`${index === page ? 'customPagination active' : 'customPagination'}`}>
                                                                    <PaginationLink href="#" onClick={() => handlePageChange(index)}>
                                                                        {index + 1}
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                            ))
                                                        ) : (
                                                            <>
                                                                {page > 0 && (
                                                                    <PaginationItem key={0} className="customPagination">
                                                                        <PaginationLink href="#" onClick={() => handlePageChange(0)}>
                                                                            1
                                                                        </PaginationLink>
                                                                    </PaginationItem>
                                                                )}

                                                                {page > 1 && (
                                                                    <PaginationItem disabled>
                                                                        <PaginationLink href="#">...</PaginationLink>
                                                                    </PaginationItem>
                                                                )}

                                                                {Array.from({ length: 3 }, (_, index) => (
                                                                    <PaginationItem key={page - 1 + index} active={page - 1 + index === page} className={`${page - 1 + index === page ? 'customPagination active' : 'customPagination'}`}>
                                                                        <PaginationLink href="#" onClick={() => handlePageChange(page - 1 + index)}>
                                                                            {page - 1 + index + 1}
                                                                        </PaginationLink>
                                                                    </PaginationItem>
                                                                ))}

                                                                {page < totalPages - 2 && (
                                                                    <PaginationItem disabled>
                                                                        <PaginationLink href="#">...</PaginationLink>
                                                                    </PaginationItem>
                                                                )}

                                                                {page < totalPages - 1 && (
                                                                    <PaginationItem key={totalPages - 1} className="customPagination">
                                                                        <PaginationLink href="#" onClick={() => handlePageChange(totalPages - 1)}>
                                                                            {totalPages}
                                                                        </PaginationLink>
                                                                    </PaginationItem>
                                                                )}
                                                            </>
                                                        )}

                                                    </span>

                                                    <PaginationItem disabled={page === totalPages - 1}>
                                                        <PaginationLink next href="#" onClick={() => handlePageChange(page + 1)} className='nextbtn'>
                                                            Next <i className='bi bi-arrow-right align-bottom'></i>
                                                        </PaginationLink>
                                                    </PaginationItem>
                                                </Pagination>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}
SwapInCome.propTypes = {
    userHistory: PropTypes.shape({
        data: PropTypes.arrayOf(
            PropTypes.shape({
                data: PropTypes.array.isRequired,
                pagination: PropTypes.shape({
                    total: PropTypes.number.isRequired
                }).isRequired
            }).isRequired
        ).isRequired
    }).isRequired,
    setRowsPerPage: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};
export default SwapInCome;